<template>
  <div style="position: relative">
    <div class="bg">
      <div class="leftTop"></div>
      <div class="rightTop"></div>
      <div class="leftBottom"></div>
      <div class="rightBottom"></div>
      <div class="leftCenter"></div>
      <div class="rightCenter"></div>
      <div class="draw-content">
        <div class="title">浦江显绿色招采服务平台抽签系统</div>
        <div class="czqy">
          <!-- 标题 -->
          <div id="cqType" class="cqType" v-html="title"></div>
          <!-- 抽签流程 -->
          <div class="cqlc" v-show="!sfSet">
            <div class="icon_sixB lf">
              <div>1</div>
              <p>设置抽签规则</p>
            </div>
            <div class="icon_next lf"></div>
            <div class="icon_sixB lf">
              <div>2</div>
              <p>开始抽签</p>
            </div>
          </div>
          <!-- 抽签池 -->
          <div class="cqc" v-show="sfSet">
            <div class="cqItem">
              <p>
                从{{ allNum.length }}个编号中，抽取{{
                  isGs == 1 ? num1 : isGs == 2 ? num2 : num3
                }}个编号
              </p>
            </div>
            <div>
              <!-- 当前抽奖结果 -->
              <div
                class="batch flexbox"
                v-show="!running && currentLucker.length > 0"
                v-cloak
              >
                <template v-if="isNaN(currentLucker[0])">
                  <p
                    class="player"
                    v-for="(item, index) in currentLucker"
                    :key="index"
                    v-html="item"
                  ></p>
                </template>
                <template v-else>
                  <span v-for="(item, index) in currentLucker" :key="index">{{
                    item
                  }}</span>
                </template>
              </div>
              <!-- 动画 -->
              <div id="myCanvasContainer" class="pond-2">
                <canvas width="500" height="500" id="myCanvas" ref="canvas">
                  <p>换个现代浏览器吧！</p>
                </canvas>
              </div>
              <!-- 动态转圈数字 -->
              <div id="tags">
                <ul>
                  <li v-for="(tag, index) in members" :key="index">
                    <a
                      onclick="return false"
                      style="height: auto; font-size: 40px"
                      v-html="tag"
                    >
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="btns">
          <button type="button" @click="isMask = true" :disabled="sfSet">
            抽签设置
          </button>
          <button
            type="button"
            @click="start()"
            :disabled="running || isOver || !sfSet"
          >
            开始抽签
          </button>
          <button
            type="button"
            @click="stop()"
            :disabled="!running || isOver || !sfSet"
          >
            停止抽签
          </button>
          <button
            type="button"
            @click="cqOver()"
            :disabled="running || !sfSet || allDisabled"
          >
            抽签结束
          </button>
        </div>
      </div>
      <div class="mask" v-show="isMask" v-cloak>
        <div class="pop" :class="isOver ? 'small' : ''">
          <template v-if="!isOver">
            <div class="close" @click="isMask = false"></div>
            <p class="cqTitle">抽签规则设置</p>
            <ul class="setGzBtn">
              <li :class="isGs == 1 ? 'show' : ''" @click="isGs = 1">
                输入个数
              </li>
              <li :class="isGs == 2 ? 'show' : ''" @click="isGs = 2">
                输入编号
              </li>
              <li :class="isGs == 3 ? 'show' : ''" @click="isGs = 3">
                设置编号
              </li>
            </ul>
            <div class="setGz">
              <div v-show="isGs == 1" class="gz">
                <div>
                  抽取<input
                    type="text"
                    class="text"
                    v-model="num1"
                    v-num2
                  />个数值
                </div>
                <div>
                  抽取范围
                  <input
                    type="text"
                    class="text"
                    v-model="numPrev"
                    v-enternumber2
                    @change="yzA"
                  />到<input
                    type="text"
                    class="text"
                    v-model="numNext"
                    v-enternumber2
                    @change="yzB"
                  />,小数位数
                  <select v-model="ws" class="text">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option></select
                  >位,
                  <button
                    type="button"
                    class="btn-true btn-s"
                    @click="setAllNum"
                    :disabled="canput"
                    style="margin-left: 40px"
                  >
                    放入抽签池
                  </button>
                  <p class="ytc">
                    只允许填写数字，支持0、正值和负值。最多保留2位小数。
                  </p>
                  <p class="ytc">数值范围：-100到100之间。</p>
                </div>
                <div v-if="allNum.length">
                  <p>剔除以下编号</p>
                  <input
                    type="text"
                    class="text"
                    v-model="delNum"
                    style="margin-left: 0; width: 100px"
                  />
                  <button
                    type="button"
                    class="btn-true btn-s"
                    @click="delTotal1"
                    :disabled="!delNum"
                  >
                    剔除
                  </button>
                  <button
                    type="button"
                    class="btn-true btn-s"
                    @click="resetTotal1"
                    :disabled="!delNumAll"
                  >
                    恢复
                  </button>
                  <p class="ytc">已剔除数字：{{ delNumAll }}</p>
                </div>

                <div>
                  抽取相同的数值
                  <label class="label"
                    ><input type="radio" v-model="flag" value="1" />允许</label
                  >
                  <label class="label"
                    ><input
                      type="radio"
                      v-model="flag"
                      value="2"
                    />不允许</label
                  >
                </div>
              </div>
              <div v-show="isGs == 2" class="gz">
                <div>
                  从以下编号中抽取<input
                    type="text"
                    class="text"
                    v-model="num2"
                    v-num2
                  />个
                </div>
                <div>
                  <p>
                    请输入参与抽签的值
                    <label class="label"
                      ><input
                        type="radio"
                        v-model="isNum"
                        value="1"
                        @change="addval = ''"
                      />数字</label
                    >
                    <label class="label"
                      ><input
                        type="radio"
                        v-model="isNum"
                        value="2"
                        @change="addval = ''"
                      />其他</label
                    >
                  </p>
                  <input
                    v-if="isNum == 1"
                    type="text"
                    class="text"
                    v-model="addval"
                    @change="yzIsNum()"
                    style="width: 480px; margin-left: 0"
                    :input="proving()"
                  />
                  <input
                    v-else
                    type="text"
                    class="text"
                    v-model="addval"
                    @change="yz()"
                    style="width: 480px; margin-left: 0"
                    maxlength="40"
                  />
                  <button
                    type="button"
                    class="btn-true btn-s"
                    @click="addTotal2"
                    :disabled="!addval"
                  >
                    添加
                  </button>
                  <p class="ytc">
                    此处允许输入汉字、大小写字母和数字，最多输入40个字符
                  </p>
                </div>
                <div>
                  抽取相同的数值
                  <label class="label"
                    ><input type="radio" v-model="flag" value="1" />允许</label
                  >
                  <label class="label"
                    ><input
                      type="radio"
                      v-model="flag"
                      value="2"
                    />不允许</label
                  >
                </div>
              </div>
              <div v-show="isGs == 3" class="ytc" style="font-size: 16px">
                <div>
                  投标单位家数<input
                    type="text"
                    class="text"
                    v-model="addUnitVal"
                    v-num2
                  />家
                </div>
                <div>
                  <p class="ytc" style="font-size: 16px">抽取规则：</p>
                </div>
                <div class="cq">
                  实行一轮抽签，抽取
                  <input
                    type="text"
                    class="text"
                    v-model="num3"
                    style="margin-left: 0; width: 100px"
                  />
                  个编号
                  <button
                    type="button"
                    class="btn-true btn-s"
                    @click="setAllNum2"
                    :disabled="canput"
                    style="margin-left: 40px"
                  >
                    放入抽签池
                  </button>
                </div>
                <div class="tips">注意：投标单位家数必须>抽取的编号数</div>
              </div>
              <div class="cqArr">
                <p>抽签池</p>
                <div id="scroll">
                  <template v-if="isNaN(allNum[0])">
                    <p
                      v-for="(item, index) in allNum"
                      :key="item"
                      class="company"
                    >
                      <span>{{ item }}<b @click="delTotal2(index)"></b></span>
                    </p>
                  </template>
                  <template v-else>
                    <span v-for="item in allNum" :key="item">{{ item }}</span>
                  </template>
                </div>
                <button
                  type="button"
                  class="btn-true btn-s"
                  @click="resetAll"
                  :disabled="allNum.length == 0"
                >
                  全部清空
                </button>
              </div>
              <div class="btn-box">
                <button
                  type="button"
                  class="btn-true"
                  @click="saveSet"
                  :disabled="canSet"
                >
                  确定
                </button>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="close" @click="refresh()" v-show="!time"></div>
            <p class="cqTitle">抽签结果</p>
            <div class="cqjg">
              <div class="cqjgContent">
                <p>本次抽签结束！</p>
                <div v-if="isNaN(currentLucker[0])" class="paddingLeft">
                  <span>抽签结果：</span>
                  <p v-for="(b, i) in currentLucker" :key="i">{{ b }}</p>
                </div>
                <div v-else>
                  抽签结果：
                  <span v-for="(b, i) in currentLucker" :key="i">
                    <template v-if="i == currentLucker.length - 1">
                      {{ b }}
                    </template>
                    <template v-else> {{ b }}、 </template>
                  </span>
                </div>
              </div>
              <div class="btn-box">
                <button
                  type="button"
                  class="btn-true"
                  @click="refresh()"
                  v-show="!time"
                >
                  同步结果
                </button>
                <button
                  type="button"
                  class="btn-true"
                  :disabled="time"
                  v-show="time"
                >
                  关闭倒计时：{{ time }}
                </button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/js/tagcanvas.min";
export default {
  name: "",
  directives: {
    // 自定义指令：输入数字和小数
    enternumber2: {
      inserted: function (el) {
        el.addEventListener("input", (e) => {
          var val = el.value;
          val = val.replace(/[^\d.-]/g, "");
          val = val.replace(/^\./g, "");
          val = val.replace(/\.{2,}/g, "");
          val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
          val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
          val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
          if (val != el.value) {
            el.value = val;
            el.dispatchEvent(new Event("input"));
          }
        });
      },
    },
    // 自定义指令：输入整数
    num2: {
      inserted: function (el) {
        el.addEventListener("input", (e) => {
          var val = el.value;
          val = val.replace(/[^\d]/g, "");
          if (val != el.value) {
            el.value = val;
            el.dispatchEvent(new Event("input"));
          }
        });
      },
    },
  },
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      isGs: localStorage.getItem("isGs") ? localStorage.getItem("isGs") : 1, //判断抽签规则
      numPrev: "",
      numNext: "",
      ws: "", //保留几位小数
      delNum: "",
      delNumAll: "",
      total1: localStorage.getItem("total1")
        ? JSON.parse(localStorage.getItem("total1"))
        : [], //输入的总单位数
      num1: localStorage.getItem("num1")
        ? Number(localStorage.getItem("num1"))
        : "", //抽取的个数

      total2: localStorage.getItem("total2")
        ? JSON.parse(localStorage.getItem("total2"))
        : [], //输入的总单位数
      num2: localStorage.getItem("num2")
        ? Number(localStorage.getItem("num2"))
        : "", //
      num3: localStorage.getItem("num3")
        ? Number(localStorage.getItem("num3"))
        : "", //
      addval: "", //当前新增的值
      flag: localStorage.getItem("flag")
        ? Number(localStorage.getItem("flag"))
        : 2, //是否允许抽取相同的数
      sfSet: localStorage.getItem("isGs") ? true : false, //判断是否设置完成
      running: false, //是否在抽签动画
      currentLucker: [], //当前轮中签者
      members: [], //滚球数
      isMask: false, //是否弹窗
      title: "抽签流程",
      isOver: localStorage.getItem("isOver") ? true : false, //是否抽签完成
      allDisabled: false, //
      time: 0,
      isNum: 1,
      addUnitVal: "",
      total3: localStorage.getItem("total3")
        ? JSON.parse(localStorage.getItem("total3"))
        : [],
    };
  },
  computed: {
    canput() {
      if (this.isGs == 3) {
        if (this.num3 == "" || this.addUnitVal == "") {
          return true;
        } else if (this.num3 !== "" && this.addUnitVal == "") {
          return true;
        } else if (Number(this.addUnitVal) <= Number(this.num3)) {
          return true;
        } else {
          return false;
        }
      } else if (
        (!this.numPrev && this.numPrev !== 0) ||
        (!this.numNext && this.numNext !== 0) ||
        (!this.ws && this.ws !== 0)
      ) {
        return true;
      } else {
        let range = Number(this.numNext - this.numPrev).toFixed(2);
        if (this.ws == 0 && range >= 0) return false;
        else if (this.ws == 1 && range >= 0.1) return false;
        else if (this.ws == 2 && range >= 0.01) return false;
        else return true;
      }
    },
    allNum() {
      return this.isGs == 1
        ? this.total1
        : this.isGs == 2
        ? this.total2
        : this.total3;
    },
    canSet() {
      //判断是否可以保存设置
      if (this.isGs == 1) {
        return this.total1.length &&
          this.num1 &&
          this.num1 <= this.total1.length
          ? false
          : true;
      } else if (this.isGs == 3) {
        return (
          this.total3.length &&
          this.num3 &&
          Number(this.addUnitVal) <= Number(this.num3)
        );
      } else {
        return this.total2.length &&
          this.num2 &&
          this.num2 <= this.total2.length
          ? false
          : true;
      }
    },
  },
  watch: {},
  mounted() {},
  methods: {
    //验证起始值
    yzA() {
      if (Number(this.numPrev) > 100 || Number(this.numPrev) < -100) {
        this.numPrev = "";
      } else if (this.numNext && Number(this.numPrev) > Number(this.numNext)) {
        this.numPrev = "";
      }
    },
    yzB() {
      if (Number(this.numNext) > 100 || Number(this.numNext) < -100) {
        this.numNext = "";
      } else if (this.numPrev && Number(this.numPrev) > Number(this.numNext)) {
        this.numNext = "";
      }
    },
    //验证剔除的值
    yzNum() {
      var reg = /^((-?[1-9]+\d*)(.\d{1,2})?|-?0(.\d{1,2})|^0)$/;
      if (!reg.test(this.delNum)) {
        this.delNum = "";
      }
    },
    //方式2 输入的编号 汉字或数字，30字以内
    yz() {
      var reg = /^[\u4E00-\u9FA5\dA-Za-z]{1,40}$/;
      if (!reg.test(this.addval)) {
        this.addval = "";
      }
    },
    yzIsNum() {
      var flag = /\.$/g.test(this.addval);
      if (flag) {
        this.addval = this.addval.split(".")[0];
      }
    },
    //验证输入数据是否正数，小数点一位
    proving() {
      // this.addval 是input的值
      // 先把非数字的都替换掉，除了数字和.
      this.addval = this.addval.replace(/[^\d.]/g, "");
      //.0 去掉
      this.addval = this.addval.replace(/\.0$/g, "");
      // 必须保证第一个为数字而不是.
      this.addval = this.addval.replace(/^\./g, "");
      //除了0.不能是0开头
      this.addval = this.addval.replace(/^0\d$/g, Number(this.addval));
      // 保证只有出现一个.而没有多个.
      this.addval = this.addval.replace(/\.{2,}/g, "");
      // 保证.只出现一次，而不能出现两次以上
      this.addval = this.addval
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      let index = -1;
      for (let i in this.addval) {
        if (this.addval[i] === ".") {
          index = i;
        }
        if (index !== -1) {
          if (i - index > 4) {
            this.addval = this.addval.substring(0, this.addval.length - 1);
          }
        }
      }
    },
    //方式2-根据序号删除编号
    delTotal2(index) {
      this.total2.splice(index, 1);
    },
    //方式2-添加编号
    addTotal2() {
      var flag = this.total2.includes(this.addval);
      if (flag) {
        alert("当前编号已存在");
      } else {
        this.total2.push(this.addval);
        this.addval = "";
      }
    },
    //清空抽签池
    resetAll() {
      if (this.isGs == 1) {
        this.total1 = [];
      } else if (this.isGs == 3) {
        this.total3 = [];
      } else {
        this.total2 = [];
      }
    },
    // 方式三放入抽签池
    setAllNum2() {
      this.total3 = [];
      for (let i = 1; i <= this.addUnitVal; i++) {
        this.total3.push(i);
      }
    },
    //方式一放入抽签池
    setAllNum() {
      this.total1 = [];
      var a = Number(this.numPrev);
      var b = Number(this.numNext);
      var ws = this.ws == 1 ? 0.1 : this.ws == 2 ? 0.01 : 1;
      for (var index = a; index <= b; ) {
        var n = index.toFixed(this.ws) == 0 ? 0 : index.toFixed(this.ws);
        this.total1.push(n);
        index =
          Number(
            this.ws == 1
              ? index.toFixed(1)
              : this.ws == 2
              ? index.toFixed(2)
              : index
          ) + ws;
        console.log(index);
      }
      this.delNumAll = "";
      this.delNum = "";
    },
    //方式一 剔除编号
    delTotal1() {
      var index = this.total1.findIndex((a) => a == Number(this.delNum));
      if (index != -1) {
        this.total1.splice(index, 1);
        this.delNumAll = this.delNumAll
          ? this.delNumAll + "、" + this.delNum
          : this.delNum;
        this.delNum = "";
      } else {
        alert("当前编号不存在");
      }
    },
    //方式一恢复剔除的编号
    resetTotal1() {
      this.delNumAll = "";
      this.delNum = "";
      this.setAllNum();
    },
    // 保存设置
    saveSet() {
      if (this.isGs == 1) {
        localStorage.setItem("isGs", 1);
        localStorage.setItem("num1", this.num1);
        localStorage.setItem("total1", JSON.stringify(this.total1));
      } else if (this.isGs == 3) {
        localStorage.setItem("isGs", 3);
        localStorage.setItem("num1", this.num3);
        localStorage.setItem("total1", JSON.stringify(this.total3));
      } else {
        localStorage.setItem("isGs", 2);
        localStorage.setItem("num2", this.num2);
        localStorage.setItem("total2", JSON.stringify(this.total2));
      }
      this.title = "抽签池";
      this.isMask = false;
      this.sfSet = true;
    },
    getSpeed: function () {
      return [0.1 * Math.random() + 0.01, -(0.1 * Math.random() + 0.01)];
    },
    getLuck() {
      //LotteryPool:抽签池内所有数值
      //num:要抽取的个数
      //flag:是否允许重复
      var LotteryPool =
        this.isGs == 1
          ? this.total1
          : this.isGs == 2
          ? this.total2
          : this.total3;
      var num =
        this.isGs == 1 ? this.num1 : this.isGs == 2 ? this.num2 : this.num3;
      var luckIndex = [];
      var currentLucker = [];
      for (var i = 0; i < num; i++) {
        var index = Math.floor(Math.random() * LotteryPool.length);
        if (this.flag == 1) {
          currentLucker.push(LotteryPool[index]);
        } else {
          if (luckIndex.includes(index)) {
            i = i - 1;
          } else {
            luckIndex.push(index);
            currentLucker.push(LotteryPool[index]);
          }
        }
      }
      return currentLucker;
    },
    // 开始抽签
    start: function () {
      var _this = this;
      _this.running = true;
      window.TagCanvas.SetSpeed("myCanvas", [5, 1]);
      // setTimeout(function(){_this.stop()},2000);
    },
    // 抽签动画结束
    stop: function () {
      let _this = this;
      _this.running = false;
      _this.isOver = true;
      localStorage.setItem("isOver", true);
      //生成随机数
      _this.currentLucker = _this.getLuck();
      window.TagCanvas.SetSpeed("myCanvas", _this.getSpeed());
      window.TagCanvas.Reload("myCanvas");
    },
    //抽签结束
    cqOver() {
      this.allDisabled = true;
      this.isOver = true; //弹窗内容控制
      this.isMask = true; //弹窗出现
      localStorage.removeItem("total1");
      localStorage.removeItem("total2");
      localStorage.removeItem("total3");
      localStorage.removeItem("num1");
      localStorage.removeItem("num2");
      localStorage.removeItem("num3");
      localStorage.removeItem("isGs");
      localStorage.removeItem("isOver");
    },
    init: function () {
      try {
        TagCanvas.Start("myCanvas", "tags", {
          textColour: "#ffffff",
          outlineColour: "transparent",
          dragControl: 1,
          decel: 0.95,
          textHeight: 14,
          minSpeed: 0.05,
          txtOpt: true,
          wheelZoom: false, //鼠标不可放大放小
          initial: [0.1 * Math.random() + 0.01, -(0.1 * Math.random() + 0.01)],
        });
      } catch (e) {
        // something went wrong, hide the canvas container
        document.getElementById("myCanvasContainer").style.display = "none";
      }
    },
    refresh() {
      let kbxmCsForm = this.$route.query.kbxmCsForm;
      let targetKey = this.$route.query.targetKey;
      if (kbxmCsForm && targetKey) {
        let kbxmCsForm = JSON.parse(this.$route.query.kbxmCsForm);
        // 为kbxmCsForm增加key
        kbxmCsForm[targetKey] = this.currentLucker[0];
        kbxmCsForm["jslx"] = "1";
        this.$api.saveSzcs(kbxmCsForm).then((res) => {
          if (!res.data.meta.success) {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
            return;
          }
          this.$message({
            type: "success",
            message: "参数设置抽取成功！",
          });
          this.$api
            .postSaveCqRecord({ ballNumber: this.currentLucker[0] })
            .then((res2) => {
              if (res2.data.meta.success) {
                const name = this.$route.query.beforeName;
                const query = this.$route.query.beforeQuery || {};
                if (name && query) {
                  this.$router.push({
                    name: name,
                    query: JSON.parse(query),
                  });
                }
              }
            });
        });
      } else {
        this.time = 10;
        var _this = this;
        var timeOut = setInterval(function () {
          _this.time--;
          if (_this.time == 0) {
            _this.isMask = false;
            location.reload();
          }
        }, 1000);
      }
    },
  },
  mounted() {
    // 生成滚球数字
    for (var i = 1; i < 201; i++) {
      this.members.push(i);
    }
    this.$nextTick(function () {
      this.init();
    });
  },
};
</script>
<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  word-wrap: break-word;
  word-break: break-all;
}
button,
input {
  cursor: pointer;
  vertical-align: middle;
}
html,
body {
  font-family: "Microsoft YaHei", "微软雅黑", arial;
  font-size: 16px;
}
.bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url("./img/bg.png") no-repeat;
  background-size: cover;
  z-index: 1;
  min-width: 1190px;
  min-height: 880px;
}
.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(00, 00, 00, 0.5);
  min-width: 1190px;
  min-height: 880px;
}
.leftTop {
  position: absolute;
  top: 20px;
  left: 40px;
  background: url("./img/left_1.png") no-repeat;
  width: 630px;
  height: 154px;
}
.leftCenter {
  position: absolute;
  top: 174px;
  left: 42px;
  bottom: 496px;
  background: url("./img/left_2.png") repeat;
  width: 14px;
}
.leftBottom {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: url("./img/left_3.png") no-repeat;
  width: 419px;
  height: 476px;
}
.rightTop {
  position: absolute;
  top: 20px;
  right: 40px;
  background: url("./img/right_1.png") no-repeat;
  width: 630px;
  height: 154px;
}
.rightCenter {
  position: absolute;
  top: 174px;
  right: 42px;
  bottom: 496px;
  background: url("./img/right_2.png") repeat;
  width: 14px;
}
.rightBottom {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: url("./img/right_3.png") no-repeat;
  width: 419px;
  height: 476px;
}
.draw-content {
  width: 100%;
  height: 100%;
  padding: 20px;
}
.title {
  width: 830px;
  height: 69px;
  line-height: 58px;
  margin: 5px auto 30px;
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: bold;
  background: url("./img/top_1.png") no-repeat center;
  background-size: 100%;
}
.czqy {
  position: absolute;
  top: 125px;
  left: 150px;
  right: 150px;
  bottom: 165px;
  background: url("./img/bg2.png") no-repeat;
  background-size: 100% 100%;
  padding: 50px 40px;
}
.btns {
  position: absolute;
  bottom: 70px;
  left: 0;
  width: 100%;
  text-align: center;
}
.btns button {
  width: 250px;
  height: 60px;
  border: 1px solid #608add;
  border-radius: 10px;
  outline: none;
  color: #fff;
  font-size: 18px;
  margin: 0 5px;
  cursor: pointer;
  background: linear-gradient(
    to bottom,
    #2a6ddc 0%,
    #1753b7 50%,
    #0745a8 54%,
    #2a6ddc 100%
  );
}
.btns button:disabled {
  color: #fff;
  border: 1px solid transparent;
  cursor: not-allowed;
  background: linear-gradient(
    to bottom,
    #adacac 0%,
    #888888 50%,
    #848282 54%,
    #adacac 100%
  );
}
.cqType {
  width: 289px;
  height: 50px;
  line-height: 50px;
  margin: -52px auto 0;
  text-align: center;
  color: #fff;
  font-size: 24px;
  background: url("./img/top_2.png") no-repeat;
}
.cqlc {
  width: 580px;
  height: 232px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -290px;
  margin-top: -116px;
}
.icon_sixB {
  width: 210px;
  height: 232px;
  background: url("./img/lbx.png") center no-repeat;
  color: #fff;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.icon_sixB div {
  width: 38px;
  height: 38px;
  line-height: 34px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin: 65px auto 24px;
}
.icon_next {
  width: 160px;
  height: 232px;
  background: url("./img/jt.png") center no-repeat;
}
.lf {
  float: left;
}
.rt {
  float: right;
}
.mask .pop {
  width: 1200px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -600px;
  margin-top: -250px;
  background: rgba(19, 46, 92, 0.9);
  z-index: 9;
  padding: 0px 20px 20px 60px;
}
.mask .pop:before {
  content: "";
  display: block;
  position: absolute;
  top: -12px;
  bottom: 0;
  left: 0;
  right: 0;
  width: 1200px;
  height: 612px;
  background: url("./img/tck_1.png") no-repeat;
  background-size: 100%;
  z-index: -1;
}
.mask .pop.small {
  width: 600px;
  height: 300px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -300px;
  margin-top: -153px;
  background: rgba(19, 46, 92, 0.9);
  z-index: 9;
  padding: 0px 60px 40px;
}
.mask .pop.small:before {
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  bottom: 0;
  left: 0;
  right: 0;
  width: 600px;
  background: url("./img/tck_1.png") no-repeat;
  background-size: 100%;
  z-index: -1;
}
.mask .pop .close {
  position: absolute;
  width: 16px;
  height: 16px;
  right: 15px;
  top: 15px;
  background: url("./img/close.png") center no-repeat;
  cursor: pointer;
}
.cqTitle {
  color: #fff;
  font-size: 25px;
  position: relative;
  top: -15px;
  text-align: center;
}
.setGzBtn li {
  width: 140px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  list-style: none;
  position: relative;
  text-align: center;
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
}
.setGzBtn li:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 140px;
  height: 40px;
  transform: skewX(-30deg);
  z-index: -1;
  background: linear-gradient(0deg, #71809b, #5c6d8d, #71809b, #7f8fac);
  border: 1px solid #8a99b5;
}
.setGzBtn li.show {
  font-weight: bold;
}
.setGzBtn li.show:after {
  background: linear-gradient(0deg, #2a6ddc, #0745a8, #1753b7, #1f63d5);
  border: 1px solid #608add;
}
.setGz {
  margin-top: 20px;
  position: relative;
  height: calc(100% - 90px);
  overflow-y: auto;
}
.setGz .gz {
  width: 55%;
}
.setGz .gz > div {
  background: rgba(16, 87, 166, 0.1);
  line-height: 35px;
  font-size: 16px;
  color: #fff;
  margin-bottom: 10px;
  padding: 15px 20px;
}
.ytc {
  color: #69ebfa;
  font-size: 14px;
  line-height: 20px;
  margin-top: 5px;
}
.cqArr {
  width: 400px;
  height: 420px;
  position: absolute;
  right: 0;
  top: 0;
  background: rgba(16, 101, 194, 0.2);
  border: 1px solid #608add;
  border-radius: 3px;
  color: #fff;
}
.cqArr > p {
  text-align: center;
  line-height: 40px;
}
.cqArr > div {
  height: 330px;
  overflow-y: auto;
}
.cqArr div > span {
  width: 70px;
  display: inline-block;
  text-align: center;
  line-height: 36px;
}
.cqArr .company {
  padding: 0 10px;
  line-height: 36px;
}
.cqArr .company span {
  display: inline-block;
  position: relative;
  padding-right: 15px;
}
.cqArr .company b {
  position: absolute;
  width: 10px;
  height: 10px;
  right: 0;
  top: 8px;
  background: url("./img/close.png") center no-repeat;
  cursor: pointer;
}
.cqArr button {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
input.text,
select.text {
  outline: none;
  margin: 0 10px;
  padding: 0 5px;
  color: #0745a8;
  font-size: 16px;
  width: 66px;
  height: 36px;
  line-height: 36px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #ffffff;
  border-radius: 3px;
}
option {
  color: #333;
}
.pop .btn-box {
  /* position: absolute; */
  /* bottom:10px; */
  /* left:0; */
  width: 100%;
  text-align: center;
}
.btn-true {
  width: 140px;
  height: 42px;
  color: #fff;
  background: linear-gradient(0deg, #2a6ddc, #0745a8, #1753b7, #1f63d5);
  border: none;
  border-radius: 5px;
}
.btn-s {
  width: auto;
  min-width: 80px;
  height: 34px;
  padding: 0 10px;
  background: #1065c2;
}
.icon_add,
.icon_del {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url("./img/add.png") center no-repeat;
  cursor: pointer;
}
.icon_del {
  background: url("./img/del.png") center no-repeat;
}
.cqItem p {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  height: 44px;
  line-height: 44px;
  padding: 0 100px 0 10px;
  display: inline-block;
  background: linear-gradient(
    to right,
    rgba(99, 132, 255, 0.3),
    rgba(255, 255, 255, 0.05)
  );
}
.pond-2 {
  width: 500px;
  height: 500px;
  margin: 0 auto;
}
.batch {
  position: absolute;
  min-width: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(5, 53, 133, 0.9);
  border: 1px solid #608add;
  box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.5);
  border-radius: 3px;
  padding: 40px 60px;
  text-align: center;
  font-size: 32px;
  line-height: 50px;
  color: #fff;
  max-height: 50vh;
  overflow-y: scroll;
}
.batch span {
  display: inline-block;
  margin: 0 20px;
}
button:disabled {
  background: #999;
  color: #fff;
  cursor: not-allowed;
}
.cqjgContent {
  color: #fff;
  font-size: 18px;
  line-height: 40px;
  overflow-y: scroll;
}
.cqjgContent .paddingLeft {
  padding-left: 90px;
  position: relative;
  margin-top: 10px;
}
.cqjgContent .paddingLeft span {
  position: absolute;
  left: 0;
  top: 0;
}

[v-cloak] {
  display: none !important;
}
.label {
  margin-left: 20px;
}
.cqjg {
  height: calc(300px - 40px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
